<template>
  <div class="new_guide_wrapper">
      <div class="top">
          <div class="content">
            <i @click="goBack()"></i>
          </div>
      </div>

      <div class="header">
        <img src="@/assets/images/new_guide/b.png" />
        <img src="@/assets/images/new_guide/t.png" />
      </div>

      <div class="new_guide">
        <div class="img-box">
          <div class="title-box">
            <span>
              <img src="@/assets/images/new_guide/tl.png">
              <strong>第1步</strong>
              <img src="@/assets/images/new_guide/tr.png">
            </span>
            <span>选择感兴趣的任务</span>
          </div>
          <img src="@/assets/images/new_guide/1.png" />
        </div>
        <div class="img-box">
          <div class="title-box">
            <span>
              <img src="@/assets/images/new_guide/tl.png">
              <strong>第2步</strong>
              <img src="@/assets/images/new_guide/tr.png">
            </span>
            <span>进入任务详情页，点击<font color="#FF5500">【开始赚钱】</font><br>下载并注册游戏账号</span>
          </div>
          <img src="@/assets/images/new_guide/2.png" />
        </div>
        <div class="img-box">
          <div class="title-box">
            <span>
              <img src="@/assets/images/new_guide/tl.png">
              <strong>第3步</strong>
              <img src="@/assets/images/new_guide/tr.png">
            </span>
            <span>注册完成后，返回任务页<br>点击<font color="#FF5500">【刷新】</font>确认游戏账号信息绑定<br>（未显示请多次刷新）</span>
          </div>
          <img src="@/assets/images/new_guide/3.png" />
        </div>
        <div class="img-box">
          <div class="title-box">
            <span>
              <img src="@/assets/images/new_guide/tl.png">
              <strong>第4步</strong>
              <img src="@/assets/images/new_guide/tr.png">
            </span>
            <span>按要求完成任务后<br>返回详情页<font color="#FF5500">【领取奖励】</font></span>
          </div>
          <img src="@/assets/images/new_guide/4.png" />
        </div>
        <div class="img-box last-img">
          <div class="title-box">
            <span>
              <img src="@/assets/images/new_guide/tl.png">
              <strong>第5步</strong>
              <img src="@/assets/images/new_guide/tr.png">
            </span>
            <span>赚到的钱可以<font color="#FF5500">直接提现哦！</font><br>去【我的】-【提现】，即可提现到账哦～</span>
          </div>
          <img src="@/assets/images/new_guide/5.png" />
        </div>
      </div>
  </div>
</template>

<style>
  body {
    background: #fff;
    font-family:PingFang-SC-Regular,Helvetica Neue,Helvetica,microsoft yahei,sans-serif;
  }
</style>

<style scoped lang="scss">
  .new_guide_wrapper {
    padding-top: .3rem;
    background-image: linear-gradient(90deg, #F81B2A 0%, #FA8B27 100%);
  }
  .top {
    display: block;
    /* width: 100%; */
    height: 0.22rem;
    color: #F5F7FA;
    position: absolute;
    z-index: 98;
    top: 0.36rem;
  }
  .top .content {
    display: flex;
    width: 3.43rem;
    padding: 0 .18rem;
    height: 0.22rem;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
  }
  .top .content i {
    float: left;
    width: 0.1rem;
    height: 0.1rem;
    border-left: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    transform: rotate(45deg);
    overflow: hidden;
  }

  .header {
    position: relative;
    display: block;
    width: 100%;
    height: 1.6rem;
    margin: 0 auto;
  }
  .header img:last-child {
    position: absolute;
    top: 0.2rem;
    left: 0;
    right: 0;
    width: 2.4rem;
    height: 0.94rem;
    margin: auto;
  }
  .header img:first-child {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1rem;
    z-index: 0;
  }

  .new_guide {
    position: relative;
    display: flex;
    flex-flow: column;
    margin-top: -0.24rem;
    z-index: 2;
  }

  .new_guide .img-box {
    padding: .24rem 0;
    background: #FFFBE7;
    margin-bottom: .08rem;
    border-radius: .2rem;
  }

  .new_guide .img-box img {
    width: 100%;
  }

  .new_guide .last-img{
    margin-bottom: .2rem;
  }
  .title-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-flow: column;
    span:first-child {
      display: flex;
      align-items: center;
      height: .26rem;
      img {
        width: .5rem;
        height: .02rem;
      }
      strong {
        margin: 0 .1rem;
        font-size: .18rem;
        color: #FF5500;
      }
    }
    span:nth-child(2) {
      display: block;
      text-align: center;
      max-width: 3.2rem;
      margin: .08rem 0 .14rem 0;
      font-size: .16rem;
      color: #333;
      line-height: .26rem;
    }
  }
</style>

<script>
export default {
  created() {
    document.title = "试玩攻略";
  },
  data() {
    return {
    }
  },
  methods: {
    goBack: function () {
      this.callClienFunc('closeWebview', '')
    },
    callClienFunc: function(fname, fval) {
      if (window.hasOwnProperty('injectedObject')) {
        window.injectedObject.setJsContent(fname, fval)
      } else {
        fval = fval? fval : {}
        let params = {method: fname, params:fval}
        params = JSON.stringify(params)
        window.Android.postMessage(params)
      }
    },
  } 
}
</script> 